import { useInView } from "react-intersection-observer";
import combineClasses from "helpers/combine-classes";
import isBrowserContext from "helpers/isBrowserContext";

export default (styles: any): any => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

    const isBrowserClass = isBrowserContext() ? styles.is_browser : undefined;
    const inViewClass = inView ? styles.is_in_view : undefined;
    const dynamicAnimationClass = styles["fadeSlideUp"];

    const classes = combineClasses(isBrowserClass, inViewClass, dynamicAnimationClass);

    return {
        inViewElementRef: ref,
        inViewClasses: classes
    };
};